import { createContext, useContext } from 'react';
import { UseIdsType } from '../utils/useIds';

export const RunPayrollDataSelectionContext = createContext<UseIdsType | null>(null);

export const useRunPayrollDataSelectionContext = () => {
  return useContext(RunPayrollDataSelectionContext);
};